module.exports = __webpack_public_path__ + "img/02_uk.8fd158e1.svg";